var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoveUpDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 281 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.09,447.06l-98.67-78.93c-5.12-4.1-12.61-3.14-16.55,2.1l-9.16,12.21c-3.74,4.99-2.88,12.03,1.95,15.97 l122.32,99.67c4.24,3.46,10.32,3.48,14.59,0.07l124.69-99.75c4.9-3.92,5.8-11.02,2.04-16.04l-9.17-12.23 c-3.9-5.21-11.32-6.19-16.45-2.18l-101.19,79.19C142.26,450.46,136.29,450.43,132.09,447.06z M148.92,64.94l98.68,78.95 c5.11,4.09,12.6,3.14,16.53-2.1l9.17-12.23c3.74-4.98,2.87-12.02-1.95-15.96L149.02,13.92c-4.24-3.45-10.31-3.48-14.58-0.07 L9.73,113.62c-4.89,3.91-5.79,11.01-2.03,16.02l9.19,12.25c3.9,5.2,11.31,6.18,16.43,2.18l101.2-79.2 C138.76,61.54,144.72,61.58,148.92,64.94z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoveUpDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MoveUpDown.89056844fee9696f37f2c7c44a684c81.svg";